import 'app/agriculture/routes/Devices/DeviceDetails/components/display/trailcam/TrailCamHistoryRowDisplay.scss';
import { TextWithIconSkeletonProps } from 'app/agriculture/components/TextWithIcon/TextWithIconSkeleton';
import { HistoryIcon } from 'app/agriculture/icons';
import { Skeleton } from '@mui/material';

export function TrailCamHistoryRowDisplaySkeleton() {
    return (
        <div className="TrailCamHistoryRowDisplay">
            <div className={'TrailCamHistoryRowDisplay--image'}>
                <Skeleton variant="rounded" width={160} height={100} />
            </div>
            <div className={'TrailCamHistoryRowDisplay--stats'}>
                <TextWithIconSkeletonProps Icon={HistoryIcon} />
            </div>
        </div>
    );
}
